import JitsiMeetJS from '@solyd/lib-jitsi-meet';

const DEFAULT_WHITEBOARD_BASE_URL = 'https://whiteboard.onlinelearningsessions.com/';

function normalizeBaseUrl(value: string): string {
  return value.endsWith('/') ? value : `${value}/`;
}

export const WHITEBOARD_BASE_URL = normalizeBaseUrl(import.meta.env.VITE_WHITEBOARD_BASE_URL ?? DEFAULT_WHITEBOARD_BASE_URL);
export const SHARED_TIMER_CUSTOM_HISTORY_LIMIT = 5;

const JITSI_CONNECTION_CONFIG = {
  clientNode: 'http://jitsi.org/jitsimeet',
  enableP2P: false,
  hosts: {
    domain: 'sessions.onlinelearningsessions.com',
    focus: 'focus.sessions.onlinelearningsessions.com',
    muc: 'conference.sessions.onlinelearningsessions.com',
  },
  p2p: {
    disableH264: true,
    enabled: false,
    preferH264: true,
    useStunTurn: true,
  },
  serviceUrl: 'wss://sessions.onlinelearningsessions.com/xmpp-websocket',
  useStunTurn: true,
  xmppPing: {
    interval: 3000,
    threshold: 5,
    timeout: 2000,
  },
} as const;

const JITSI_INIT_OPTIONS = {
  disableAudioLevels: false,
} as const;

let initialized = false;

export function initializeJitsiLibrary(): void {
  if (initialized) {
    return;
  }

  JitsiMeetJS.setLogLevel(JitsiMeetJS.logLevels.ERROR);
  JitsiMeetJS.init(JITSI_INIT_OPTIONS);
  initialized = true;
}

export function buildJitsiConnectionOptions(conferenceSlug: string, token: string | null) {
  const params = new URLSearchParams({
    room: buildBaseJitsiRoomName(conferenceSlug),
  });

  if (token) {
    params.set('token', token);
  }

  return {
    ...JITSI_CONNECTION_CONFIG,
    serviceUrl: `${JITSI_CONNECTION_CONFIG.serviceUrl}?${params.toString()}`,
  };
}

export function buildBaseJitsiRoomName(conferenceSlug: string): string {
  return conferenceSlug.trim().replace(/\s+/gu, '_').toLowerCase();
}

export function buildJitsiRoomName(conferenceSlug: string, roomSlug: string): string {
  const base = buildBaseJitsiRoomName(conferenceSlug);
  const normalizedRoom = roomSlug.trim().replace(/\s+/gu, '_').toLowerCase();

  if (normalizedRoom === 'main-room') {
    return base;
  }

  return `${base}_${normalizedRoom}`;
}

export function buildWhiteboardUrl(conferenceSlug: string, roomSlug: string, token: string | null = null): string {
  const auth = token ? 'auth/' : '';

  const url = new URL(`${auth}${buildJitsiRoomName(conferenceSlug, roomSlug)}`, WHITEBOARD_BASE_URL);

  if (token) {
    url.searchParams.set('token', token);
  }

  return url.toString();
}

export const jitsiConferenceOptions = {
  ...JITSI_CONNECTION_CONFIG,
  openBridgeChannel: true,
  startVideoMuted: true,
} as const;
